<template>
  <div id="app">
    <myheader></myheader>
    <router-view />
	<myfooter></myfooter>
  </div>
</template>
<script>
	import myfooter from "@/components/footer.vue"
	import myheader from "@/components/header.vue"
	export default {
		components: {
			myheader,
			myfooter
		},
		data() {
			return {
			}
		},
		mounted(){
			$(window).scroll(function () {
				var scrollTop = $(window).scrollTop();
				if (scrollTop > 30) {
					$('.container_box').addClass("active");
				} else {
					$('.container_box').removeClass("active");
				}
			})
		}
	}
</script>
<style lang="scss">
	
</style>
